export const valueTypes = {
    TEXT: "Free txt",
    FLOAT: "Free number float",
    INT: "Free number integer",
    BOOL: "Option Boolean",
    GLOBAL_TABLE: "Global table",
    CUSTOM_TABLE: "Custom table",
    DEFINITION: "DefNameConcept",
    FORMULA: "Formula",
  };